import React, { useEffect, useMemo, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import ITermeEtCondition from '../../models/ITermeEtCondition';
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useApi from '../../hooks/useApi';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestioTermesEtConditionsProps {
  isModeSelection?: boolean,
}

export default function GestionTermesEtConditions({ isModeSelection }: IGestioTermesEtConditionsProps) {
  const termeFormDataSource = useCustomDataSource<ITermeEtCondition, ITermeEtCondition>({ path: "termeEtCondition", primaryKey: "idTermeEtCondition" });
  const { setMainForm, selectedDataRow: selectedTerme, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged } = termeFormDataSource;
  const { getData } = useApi<object>();
  const formRef = useRef<FormRef>(null);
  const { setSelectedValue } = useContextPopupPage();

  const textAreaOptions = useMemo(() => {
    return { height: 200, maxLength: 2000 };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  return (
    <FormListBase data={termeFormDataSource}>
      <FormListBaseGrid dataSource={termeFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier)
            setMode(Mode.Lecture)
          if (setSelectedValue && e.row?.data)
            setSelectedValue(e.row.data);
        }}>
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar removeBlocked={true} headerText={`${selectedTerme?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            {/* <div style={{ position: "relative", float: "left" }}> */}
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTerme || {} as ITermeEtCondition} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem>
                <SimpleItem key={"frm-description"} dataField={"description"} />
                <SimpleItem key={"frm-texteFr"} dataField={"texteFr"} editorType={"dxTextArea"} editorOptions={textAreaOptions}>
                  <Label text='Texte français'></Label>
                </SimpleItem>
                <SimpleItem key={"frm-texteEn"} dataField={"texteEn"} editorType={"dxTextArea"} editorOptions={textAreaOptions}>
                  <Label text='Texte anglais'></Label>
                </SimpleItem>
              </GroupItem>
            </Form>
            {/* </div> */}
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedTerme || {} as ITermeEtCondition} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}
